import SchemaMismatchError from "../validators/SchemaMismatchError"

type TResponse<T> = {
  isLoading: boolean, 
  data: T | undefined, 
  error: {
    path: string,
    err: any
  } | {} | unknown,
  success: boolean
}

/**
 * 
 * @param path Api calling signature or identifier 
 * @param fetcher Resolved promise function where the action api call happens expects a return of type T
 * @returns 
 */

async function callApi<T>(path: string, fetcher: Promise<T>): Promise<TResponse<T>>{
  let isLoading = false, data: T | undefined, error = {}, success = false
  try{
    data = await fetcher
    success = true
  }
  catch(err){
    SchemaMismatchError(path, err)
    error = { path: path.toUpperCase(), err }
  }
  finally{
    isLoading = false
  }
  return { isLoading, data, error, success }
}

export default callApi